export const supportedErrorTypes: { [key: string]: string } = {
  NO_ACCESS_TO_ANY_TABLES: 'You currently do not have access to any data tables in Energy Studio - Impact',
};
